




































































































































import { Component, Vue } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import GenericEdit from "@/core/Generics/GenericEdit";
import BudgetItem from "@/models/porposal/budgetItem.model";
@Component
export default class BudgetItemEdit extends GenericEdit<BudgetItem> {
  constructor() {
    super();
    this.controller = "BudgetItem";
    this.model = new BudgetItem();
  }
  protected async validate() {
    try {
      this.model.budgetExpenseId = this.$route.params.budgetExpenseId as any;
      var result = await this.$validator.validateAll();
      if (result) {
        this.edit();
        return;
      }

      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }
}
